import type { PropsWithChildren, ReactNode } from 'react'
import { Box, type SxProps, type Theme } from '@mui/material'

interface ListViewProps extends PropsWithChildren {
  header?: ReactNode
  overflow?: boolean
  sx?: SxProps<Theme>
}

export const ListView = ({ children, header, overflow = false, sx }: ListViewProps) => {
  return (
    <Box
      sx={[
        {
          backgroundColor: 'background.paper',
          p: 3,
          height: 'calc(100vh - 48px)',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          overflow: overflow ? 'auto' : 'hidden',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {header}
      {children}
    </Box>
  )
}
